import { Roles } from 'core/auth';
import { AuthState } from 'store/modules/auth';
import { normalizeArrayToEntity } from 'utils/helpers';
import { ENTITIES_MULTIPLE, ENTITIES_SINGLE } from './commercial-entities.mock';

export const AUTH_LOGIN_ENDPOINT = '/api/sf_security/v1/sessions';

export const AUTH_SUCESSFULL_REPLY = {
  authorization:
    'Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiIxMklESldUIiwibGVnYWpvIjoiRVhCMzM3OTUiLCJ1c2VyX25hbWUiOiJFWEIzMzc5NSIsIm1haWxfYWRkcmVzcyI6InBhYmxvLmx1Y2VybzFAY2xhcm8uY29tLmFyIiwiZGlzcGxheV9OYW1lIjoiUGFibG8gTWF4aW1pbGlhbm8gTHVjZXJvIiwiYXV0aG9yaXRpZXMiOlsiUk9MRV9VU0VSIiwiUk9MRV9BRE1JTiJdLCJpYXQiOjE1NjQ2NjczODcsImV4cCI6MTU2NDY2OTE4N30.ZtahK4DRIyQ3Hwv6-Q7-ZfYHETNKEU8jinNU1602nYn-8kgpyxq-dKvlLlTxbnKwM6C66K247dH1GhF3gzm8YQ',
  'refresh-authorization':
    'Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiIxMklESldUUkYiLCJsZWdham8iOiJFWEIzMzc5NSIsInVzZXJfbmFtZSI6IkVYQjMzNzk1IiwibWFpbF9hZGRyZXNzIjoicGFibG8ubHVjZXJvMUBjbGFyby5jb20uYXIiLCJkaXNwbGF5X05hbWUiOiJQYWJsbyBNYXhpbWlsaWFubyBMdWNlcm8iLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiLCJST0xFX0FETUlOIl0sImlhdCI6MTU2NDY2NzM4NywiZXhwIjoxNTY0NzUzNzg3fQ.z24FnZas5jtXnNWNdw-35l1WOxht50XqX5fR-BIr8d_RZb9W1g0M_5Ta0B_fsRi5uXsFEbeOgBkl6Yl4jUGvww',
};

export const LOGGED_STATE = {
  user: {
    userName: 'TEST',
    displayName: 'usuario',
    legajo: 'legajo',
    mailAddress: 'mail@gmail.com.ar',
    roles: [
      { name: Roles.FIJASTH_PY_VENTAS },
      { name: Roles.FIJASTH_PY_EMPLE },
    ],
    debtAuthorized: false,
  },
  selectedEntityId: '1',
};

export const INITIAL_AUTH_STATE: AuthState = {
  isFetching: false,
  selectedEntityId: '',
  user: null,
  entities: normalizeArrayToEntity([]),
  agentInfo: {
    salesPlace: '',
    status: '',
    description: '',
    documentNumber: '',
  },
  error: null,
  debtAuthorized: false,
};

export const AUTH_LOGGED_USER_WITH_SINGLE_ENTITY: AuthState = {
  ...INITIAL_AUTH_STATE,
  ...LOGGED_STATE,
  entities: normalizeArrayToEntity(ENTITIES_SINGLE),
};

export const AUTH_LOGGED_USER_WITH_MULTIPLE_ENTITIES: AuthState = {
  ...INITIAL_AUTH_STATE,
  ...LOGGED_STATE,
  entities: normalizeArrayToEntity(ENTITIES_MULTIPLE),
};
